import React from 'react';
import styles from './Regular.module.css';
import Button from '../button/Button';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Import your images
import result1 from "../../images/אדל מושייב תלמידות 1.webp";
import result2 from "../../images/אדל מושייב תלמידות 2.webp";
import result3 from "../../images/אדל מושייב תלמידות 3.webp";
import result4 from "../../images/אדל מושייב תלמידות 4.webp";

const Recommendations = () => {
  const images = [
    result1, result2, result3, result4
  ];

  const sliderSettings = {
    infinite: true,
    speed: 700,
    autoplaySpeed: 2500,
    dots: false,
    autoplay: true,
    pauseOnHover: true,
    slidesToShow: window.innerWidth < 450 ? 1 :
                  window.innerWidth <= 1050 ? 2 : 3,
    slidesToScroll: 1,
  };

  const content = images.map((img, index) => ({
    type: 'image',
    src: img
  }));

  return (
    <>
      <div className={styles.title}>והכשרתי נשים</div>
      <div className={styles.explain}>
     שהפכו לעצמאיות בתחום הריסים (ולגרסה הכי טובה של עצמן)
      </div>
      <div className={styles.sliderContainer}>
        <Slider {...sliderSettings}>
          {content.map((item, index) => (
            <div key={index} itemScope itemType="http://schema.org/Review">
              {item.type === 'image' && (
                <img
                  src={item.src}
                  className={styles.image1}
                  alt={`לקוחה ממליצה מספר ${index + 1}`}
                  itemProp="image"
                  loading="lazy"
                  decoding="async"
                />
              )}
              <meta itemProp="datePublished" content={new Date().toISOString()} />
            </div>
          ))}
        </Slider>
      </div>

    </>
  );
};

export default Recommendations;